import { FC } from 'react';
import { SvgProps } from '../interfaces/Icon';

const Question: FC<SvgProps> = ({ size, className, color }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.81818C7.48131 3.81818 3.81818 7.48131 3.81818 12C3.81818 16.5187 7.48131 20.1818 12 20.1818C16.5187 20.1818 20.1818 16.5187 20.1818 12C20.1818 7.48131 16.5187 3.81818 12 3.81818ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2347 8.38574C11.8115 8.31315 11.3762 8.39268 11.006 8.61024C10.6359 8.8278 10.3546 9.16935 10.2121 9.5744C10.0455 10.048 9.5265 10.2969 9.05287 10.1303C8.57924 9.96369 8.33036 9.44468 8.49697 8.97105C8.78194 8.16095 9.34443 7.47785 10.0848 7.04273C10.8252 6.60761 11.6956 6.44855 12.542 6.59373C13.3884 6.73891 14.1561 7.17896 14.7092 7.83593C15.2621 8.49277 15.5648 9.32407 15.5636 10.1826C15.5632 11.5739 14.5318 12.4926 13.7952 12.9837C13.3992 13.2477 13.0096 13.4418 12.7226 13.5694C12.5779 13.6337 12.4559 13.6825 12.3681 13.716C12.3241 13.7328 12.2884 13.7458 12.2625 13.755L12.2309 13.7661L12.2208 13.7695L12.2173 13.7707L12.2159 13.7712C12.2159 13.7712 12.2148 13.7715 11.9273 12.9091L12.2148 13.7715C11.7384 13.9303 11.2236 13.6729 11.0648 13.1966C10.9062 12.7206 11.1631 12.2061 11.6388 12.047L11.6533 12.0419C11.6673 12.0369 11.6903 12.0286 11.7208 12.0169C11.7821 11.9936 11.8733 11.9572 11.9842 11.9079C12.2086 11.8082 12.5008 11.6614 12.7866 11.4709C13.4135 11.0529 13.7455 10.6083 13.7455 10.1818L13.7455 10.1805C13.7461 9.75108 13.5948 9.33533 13.3182 9.00684C13.0417 8.67836 12.6579 8.45833 12.2347 8.38574Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0909 16.5455C11.0909 16.0434 11.4979 15.6364 12 15.6364H12.0091C12.5112 15.6364 12.9182 16.0434 12.9182 16.5455C12.9182 17.0475 12.5112 17.4545 12.0091 17.4545H12C11.4979 17.4545 11.0909 17.0475 11.0909 16.5455Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Question;
